module.exports = __webpack_public_path__ + "img/pi-4-7.9e9e1465.jpg";